import { render, staticRenderFns } from "./label-task-info.vue?vue&type=template&id=608bf8ca&"
import script from "./label-task-info.vue?vue&type=script&lang=js&"
export * from "./label-task-info.vue?vue&type=script&lang=js&"
import style0 from "./label-task-info.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "label-task-info.vue"
export default component.exports